
import {
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    LinearScale,
    Tooltip
} from 'chart.js';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { useMutation } from 'react-query';
import AGButton from '../../../components/Button';
import Card from '../../../components/Card';
import { InterestByAreasExpertiseRes } from '../../../models';
import { httpGET } from '../../../utils/ajaxHelper';
// import AGModal from '../modalViewDetail';
import AGModal from '../../../components/Modal';
import { getDynamicLabel, getTruncatedTooltipLabel } from '../../../utils/chartHelpers';
import { OFFERING_TYPE } from '../../../utils/constant';
import { CustomBackground } from '../../inboxMessage/addInquiryModal/addInquiry.style';
import { IInterestByAreasExpertiseProps } from './interestByAreasExpertise.props';
import { BodyModal, Container } from './interestByAreasExpertise.styled';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
);

export const options = {
    responsive: true,
};


export const InterestByAreasExpertise = ({ interval, comOfferingType, orgFilter }: IInterestByAreasExpertiseProps) => {
    const backgroundColor = process.env.REACT_APP_COLOR_OF_THE_CHART?.split(",");

    const titleText = {
        [OFFERING_TYPE.SERVICE]: "Interest By Areas of Expertise",
        [OFFERING_TYPE.PRODUCT]: "Interest By Product Category",
    }

    const [interestByAreasExpertise, setInterestByAreasExpertise] = useState<InterestByAreasExpertiseRes[]>();
    const [viewDetail, setViewDetail] = useState<boolean>(false);

    const { mutate: interestByAreasExpertiseFetch } = useMutation(
        (interval: number) =>
            httpGET({
                url: "/DashboardReport/interest-by-areas-expertise",
                params: {
                    interval: interval,
                    timeZone: new Date().getTimezoneOffset() / (-60),
                    currentDate: moment().format("MM/DD/YYYY").toString(),
                    offeringType: comOfferingType?.value,
                    orgId: orgFilter?.value

                }
            }),
        {
            onSuccess: (rs) => {
                setInterestByAreasExpertise(rs);
            },
        },
    );

    useEffect(() => {
        interestByAreasExpertiseFetch(interval)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [comOfferingType, orgFilter])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => { interestByAreasExpertiseFetch(interval) }, [interval]);

    if (!interestByAreasExpertise) { return null; }

    let resultArray: InterestByAreasExpertiseRes[] = [];

    if (interestByAreasExpertise.slice(5).length > 1) {
        const firstThreeElements = interestByAreasExpertise.slice(0, 5);
        const otherElements = interestByAreasExpertise.slice(5).reduce((accumulator, currentValue) => {
            if (currentValue.count) {
                accumulator += currentValue.count;
            }
            return accumulator;
        }, 0);
        resultArray = resultArray.concat(firstThreeElements);
        const otherElement: InterestByAreasExpertiseRes = {
            secondaryServiceName: "Others",
            count: otherElements
        };
        resultArray.push(otherElement);
    } else {
        resultArray = [...interestByAreasExpertise];
    }

    // const truncateLabel = (label: string, maxLength: number) => {
    //     if (label.length > maxLength) {
    //         return label.slice(0, maxLength - 3) + '...';
    //     }
    //     return label;
    // };




    const labels = resultArray.map(e => e.secondaryServiceName);
    return (
        <Card className='h-full'>
            <AGModal
                visible={viewDetail}
                footer={<>
                    <AGButton onClick={() => setViewDetail(false)} type='Secondary'>Close</AGButton>
                </>}
                toggleModal={() => setViewDetail(false)}
                title={titleText[comOfferingType?.value as keyof typeof titleText]}
                setHeight={500}
            >
                <CustomBackground>
                    <BodyModal>
                        <h2>
                            Others:
                        </h2>
                        <ol>
                            {interestByAreasExpertise.slice(5).map((e, index) => {
                                return (
                                    <li
                                        key={index}
                                        className='item'>
                                        <label>
                                            {e.secondaryServiceName}:
                                        </label>
                                        <div className='val'>{e.count}</div>
                                    </li>
                                );
                            })}
                        </ol>

                    </BodyModal>
                </CustomBackground>
            </AGModal>
            <Container className='h-full'>
                <h2 className='mb-[16px]'>
                    {
                        titleText[comOfferingType?.value! as keyof typeof titleText]
                    }
                </h2>
                {resultArray.length > 0 ? (
                    <div className='h-full flex-1'>
                        <Bar
                            style={
                                {
                                    height: "100%",
                                    width: "100%"
                                }
                            }
                            options={{
                                onClick: function (event, elements) {
                                    if (elements.length > 0) {
                                        const index = elements[0].index;
                                        if (interestByAreasExpertise.length > 6 && index === 5 && interestByAreasExpertise.slice(0, 5).length > 1) {
                                            setViewDetail(true);
                                        }
                                    }
                                },
                                scales: {
                                    x: {
                                        grid: {
                                            display: false,
                                        },
                                        ticks: {
                                            callback: function (value: any, index) {
                                                const chart = this.chart;
                                                const width = chart.width;
                                                return getDynamicLabel(labels[index]!, width, resultArray.length);
                                            }
                                        },
                                    },
                                    y: {
                                        grid: {
                                            display: false,
                                        },
                                    },
                                },
                                responsive: true,
                                maintainAspectRatio: false,
                                plugins: {
                                    tooltip: {
                                        callbacks: {
                                            title: function (context) {
                                                const label = context[0].label ?? "";
                                                return getTruncatedTooltipLabel(label, this.chart.width);
                                            },
                                        }
                                    }
                                },
                            }}
                            data={{
                                labels,
                                datasets: [
                                    {
                                        data: resultArray.map(e => e.count),
                                        backgroundColor: backgroundColor,
                                        borderRadius: 8,
                                        barThickness: 28,
                                        borderSkipped: false,
                                    }
                                ],
                            }}
                        />
                    </div>
                ) : (<div className="no-result">
                    No results found.
                </div>)}

            </Container>
        </Card>
    );
}
